import { render, staticRenderFns } from "./authType.vue?vue&type=template&id=7610bb96&"
import script from "./authType.vue?vue&type=script&lang=js&"
export * from "./authType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports